// extracted by mini-css-extract-plugin
module.exports = {"button":"CancelButton-module__button"};